import { lazy, useEffect } from "react";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { themeChange } from "theme-change";
import "./App.css";
import checkAuth from "./app/auth";
import initializeApp from "./app/init";
import Otp from "./features/user/Otp";
import { SetPassword } from "./features/user/SetPassword";
import { removeNotificationMessage } from "./Store/Slice/headerSlice";
import { useDispatch, useSelector } from "react-redux";
import LandingPage from "./components/avitaLandingPage/LandingPage";
import TermsAndCondition from "./components/avitaLandingPage/TermsAndCondition";
import PrivacyPolicy from "./components/avitaLandingPage/PrivacyPolicy";
import RefundPolicy from "./components/avitaLandingPage/RefundPolicy";
import PaymentResponse from './features/user/PaymentResponse'
import PaymentGateway from './features/payment'
// Importing pages
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Register = lazy(() => import("./pages/Register"));
const LandingLayout = lazy(() => import("./containers/LandingPage/Layout"));

// Initializing different libraries
initializeApp();

// Check for login and initialize axios
const token = checkAuth();
function App() {
  const dispatch = useDispatch();
  const { newNotificationMessage, newNotificationStatus } = useSelector(
    (state) => state.header
  );

  useEffect(() => {
    console.log('newNotificationMessage', newNotificationMessage)
    if (newNotificationMessage !== "") {
      console.log('newNotificationStatus', newNotificationStatus)
      if (newNotificationStatus === 1)
        NotificationManager.success(newNotificationMessage, "Success", 2000);
      if (newNotificationStatus === 0)
        NotificationManager.error(newNotificationMessage, "Error", 3000);
      dispatch(removeNotificationMessage());
    }
  }, [dispatch, newNotificationMessage, newNotificationStatus]);
  useEffect(() => {
    themeChange(false);
  }, []);
  // useEffect(() => {
  //   const pathname = window.location.pathname;
  //   if (pathname.includes('/Login')) {

  //     window.location.reload();
  //   }
  // }, []);

  return (
    <>
      <NotificationContainer />
      <Router>
        <Routes>
          <Route
            path="/Login"
            element={
              !token ? <Login /> : <Navigate to="/app/dashboard" replace />
            }
          />
          <Route path="/" element={<LandingPage />} />
          <Route path="/termsandcondition" element={<TermsAndCondition />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/refundpolicy" element={<RefundPolicy />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verifyotp" element={<Otp />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/payment-status" element={<PaymentResponse />} />
          {/* Removed "/payment-gateway" (features/payment) — hardcoded ₹1 test order. */}
          <Route path="/register" element={<Register />} />
          <Route path="/*" element={<LandingLayout />} />
          <Route path="/app/*" element={token ? <Layout /> : <Login />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
